var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 16.5938H18.375V3.75C18.375 1.68225 16.6927 0 14.625 0H3.75C1.68225 0 0 1.68225 0 3.75V4.6875C0 5.20528 0.419719 5.625 0.9375 5.625H2.8125V20.25C2.8125 22.3177 4.49475 24 6.5625 24H20.25C22.3177 24 24 22.3177 24 20.25V17.5312C24 17.0135 23.5803 16.5938 23.0625 16.5938ZM1.875 3.75C1.875 2.71613 2.71613 1.875 3.75 1.875H11.3783C11.0583 2.42686 10.875 3.06745 10.875 3.75H1.875ZM6.5625 22.125C5.52863 22.125 4.6875 21.2839 4.6875 20.25V5.625H11.8125C12.3303 5.625 12.75 5.20528 12.75 4.6875V3.75C12.75 2.71613 13.5911 1.875 14.625 1.875C15.6589 1.875 16.5 2.71613 16.5 3.75V20.25C16.5 20.9328 16.6843 21.573 17.0045 22.125H6.5625ZM22.125 20.25C22.125 21.2839 21.2839 22.125 20.25 22.125C19.2161 22.125 18.375 21.2839 18.375 20.25V18.4688H22.125V20.25ZM14.625 8.96873C14.625 9.48652 14.2053 9.90623 13.6875 9.90623H7.5C6.98222 9.90623 6.5625 9.48652 6.5625 8.96873C6.5625 8.45095 6.98222 8.03123 7.5 8.03123H13.6875C14.2053 8.03123 14.625 8.45095 14.625 8.96873ZM14.625 13.25C14.625 13.7678 14.2053 14.1875 13.6875 14.1875H7.5C6.98222 14.1875 6.5625 13.7678 6.5625 13.25C6.5625 12.7322 6.98222 12.3125 7.5 12.3125H13.6875C14.2053 12.3125 14.625 12.7322 14.625 13.25ZM11.5312 17.5312C11.5312 18.049 11.1115 18.4688 10.5938 18.4688H7.5C6.98222 18.4688 6.5625 18.049 6.5625 17.5312C6.5625 17.0135 6.98222 16.5938 7.5 16.5938H10.5938C11.1115 16.5938 11.5312 17.0135 11.5312 17.5312Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5,
    y1: 19,
    x2: 22,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.04119c04fb1888dce14fda79f8e63ab1.svg";
export { ForwardRef as ReactComponent };